// Constants and Utils
import { India, MapZoom } from "../../../constants/GeneralConstants";

// construct Stretches Dropdown Items
export function constructStretchesDropdownItems(
  planSelectedStretchIds = [],
  roadStretchMap = {}
) {
  // if no stretch selected
  if (!planSelectedStretchIds || planSelectedStretchIds.length === 0) {
    return [];
  }

  const stretches = Object.values(roadStretchMap)
    .filter((stretch) => planSelectedStretchIds.includes(stretch.id))
    .map((stretch) => ({
      id: stretch.id,
      label: stretch.name,
    }));

  return stretches;
}

// Map Center and zoom from stretch
export function getMapCenterAndZoomFromStretch(roadStretchMap = {}, stretchId) {
  const stretchesData = Object.values(roadStretchMap);

  // if no stretches selected or present
  if (!stretchId || !roadStretchMap || stretchesData.length === 0) {
    return {
      center: India.mapCenter,
      zoom: India.mapZoomLevel4,
    };
  }

  // selected stretch trace[0]
  const selectedStretch = roadStretchMap[stretchId];
  return {
    center: selectedStretch.trace[0],
    zoom: MapZoom.zoomLevel13,
  };
}

// get Plan Stretches Map
export function getPlanStretchesMap(campaignPlan = {}, roadStretchMap = {}) {
  const { roadStretchOtsMap } = campaignPlan || {};
  const planStretchIds = Object.keys(roadStretchOtsMap || {});

  // filter campaign plan selected stretches
  const planStretchesMap = {};

  Object.keys(roadStretchMap).forEach((key) => {
    const stretchInfo = roadStretchMap[key];

    // if stretch is part of campaign plan then add to "planStretchesMap"
    if (planStretchIds.includes(key)) {
      planStretchesMap[key] = stretchInfo;
    }
  });

  return planStretchesMap;
}
